import React from "react";

import { faFile, faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation } from "react-i18next";
import IconButton from "../Button/Icon/IconButton";

class File extends React.Component<any, any> {
  inputRef: React.RefObject<HTMLInputElement>;
  constructor(props: any) {
    super(props);
    this.inputRef = React.createRef();
    this.state = {
      showUi: false,
      fileName: "",
      fileUrl: this.props.value,
    };
  }

  render() {
    const { t } = this.props;

    return (
      <>
        {this.state.fileName && (
          <div className="button__file-label__preview">
            <FontAwesomeIcon icon={faFile} />
            <span>{this.state.fileName}</span>
            <IconButton icon={faTrashCan} className="button__file-label__delete" type="wire-circle" color="danger" onClick={this.handleTrashClick.bind(this)} tooltip="Discard" />
          </div>
        )}
        <label className="button__file-label" htmlFor={this.props.name}>
          <span className="button__file-label__title">{t("uploadFile")}</span>
          <input
            type="file"
            id={this.props.name}
            name={this.props.name}
            ref={this.inputRef}
            className={this.props.className}
            accept={".pdf, image/*, .docx"}
            onChange={(e) => {
              const showUi = e.target.files && e.target.files.length === 1;
              // @ts-ignore
              this.setState({ showUi, fileName: showUi ? e.target.files[0].name : "" });
              const ionEvent = new CustomEvent("ionChange", {
                detail: {
                  name: this.props.name,
                  value: e.target.files && e.target.files.length === 1 ? e.target.files[0] : null,
                },
              });
              this.props.onIonChange(ionEvent);
            }}
          />
        </label>
      </>
    );
  }

  handleTrashClick = (e: any) => {
    const input = e.target.closest(".input__container--type-file").querySelector(".input__input");
    input.value = "";

    const ionEvent = new CustomEvent("ionChange", {
      detail: {
        name: this.props.name,
        value: null,
      },
    });
    this.props.onIonChange(ionEvent);

    this.setState({
      showUi: false,
      fileName: "",
    });
  };
}

export default withTranslation()(File);
